<!-- Admin Component - New 3-Panel Layout -->
<div class="admin-container" #adminContainer>

  <!-- Main Header -->
  <app-header [isAdmin]="true" (logoutEvent)="logout()"></app-header>

  <!-- Main Content Area with 3 Panels -->
  <div class="admin-content">

    <!-- Left Panel - Admin Tree Navigation -->
    <div class="admin-panel tree-panel" [style.flex]="treeAreaFlex">
      <app-admin-tree
        [isCollapsed]="isTreeCollapsed"
        [showEditMode]="showEditMode"
        (nodeSelected)="onNodeSelected($event)"
        (editModeToggled)="onEditModeToggled($event)"
        (nodeAdded)="onNodeAdded($event)"
        (nodeEdited)="onNodeEdited($event)"
        (nodeDeleted)="onNodeDeleted($event)"
        (treeRefreshed)="onTreeRefreshed()"
        (collapseStateChanged)="onTreeCollapseStateChanged($event)">
      </app-admin-tree>
    </div>

    <!-- Tree-Main Resizer -->
    <div class="panel-resizer tree-main-resizer"
         [class.resizing]="isTreeResizing"
         (mousedown)="startTreeResize($event)"
         matTooltip="Drag to resize tree panel">
      <div class="resizer-handle"></div>
    </div>

    <!-- Center Panel - Main Area -->
    <div class="admin-panel main-panel" [style.flex]="mainAreaFlex">
      <app-admin-main-area
        [selectedNode]="selectedNode"
        [bucketFolders]="bucketFolders"
        [selectedFolder]="selectedFolder"
        [processedFiles]="processedFiles"
        [isLoading]="isLoading"
        [operationResult]="operationResult"
        [showDetails]="showDetails"
        (folderSelected)="onFolderSelected($event)"
        (folderProcessed)="onFolderProcessed($event)"
        (fileSelected)="onFileSelected($event)"
        (showDetailsToggled)="onShowDetailsToggled($event)"
        (bucketsRefreshed)="onBucketsRefreshed()">
      </app-admin-main-area>
    </div>

    <!-- Main-Details Resizer (only visible when details panel is shown) -->
    <div *ngIf="showDetails"
         class="panel-resizer main-details-resizer"
         [class.resizing]="isDetailsResizing"
         (mousedown)="startDetailsResize($event)"
         matTooltip="Drag to resize details panel">
      <div class="resizer-handle"></div>
    </div>

    <!-- Right Panel - Details Panel (only visible when showDetails is true) -->
    <div *ngIf="showDetails"
         class="admin-panel details-panel"
         [style.flex]="detailsAreaFlex">
      <app-admin-details
        [selectedFile]="selectedFile"
        [isFullscreenMode]="viewMode === 'fullscreen'"
        [showMains]="true"
        (closeDetails)="onDetailsClose()"
        (showMainsChange)="onShowMainsChange($event)"
        (viewModeChange)="onViewModeChange($event)"
        (fileNavigated)="onFileNavigated($event)">
      </app-admin-details>
    </div>
  </div>

  <!-- Global Loading Overlay -->
  <div *ngIf="isLoading" class="global-loading-overlay">
    <div class="loading-content">
      <mat-progress-spinner diameter="50" mode="indeterminate" color="primary"></mat-progress-spinner>
      <p>Processing operation...</p>
    </div>
  </div>
</div>
